import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import { separate } from "../../tools/helper";
import { toast } from "react-toastify";
import { favoriteCheck, setFavorite } from "../../axios";
import { CartContext } from "../shared/context/cart-context";
import "./productOne.css";
import ProductCard from "./ProductCard/ProductCard";
import { ExistDataContext } from "../shared/context/dataExist-context";
import { useAppSelector } from "../../store/configureStore";

const ProductOne = ({ item, basketProps, hover, commingSoon, recived }) => {
  const { user } = useAppSelector((state) => state.account);
  // --------------------------------- تابعی برای گرفتن درصد تخفیف

  const discountPercentage = (originalPrice, discountedPrice) => {
    return ((originalPrice - discountedPrice) / originalPrice) * 100;
  };

  const addToFavorite = (e, id) => {
    e.preventDefault();

    if (localStorage.getItem("login")) {
      favoriteCheck(id, localStorage.getItem("phonenumber")).then(
        ({ data }) => {}
      );
      setFavorite(id, localStorage.getItem("phonenumber")).then(({ data }) => {
        toast.success("به لیست علاقه مندی ها اضافه شد");
      });
    } else {
      toast.error("لطفا ابتدا از بخش منو بالا وارد حساب کاربری خود شوید");
    }
  };

  const [cartItems, setCartItems] = useContext(CartContext);

  const [existProduct] = useContext(ExistDataContext);

  const existsInArray = (array, id) => {
    return array.some((item) => item.productID === id);
  };
  const existsInArraySecond = (array, id) => {
    return array.some((item) => item.id === id);
  };

  const addToBasketHandler = (e, value) => {
    e.preventDefault();
    if (user) {
      let Basket = [...cartItems];
      const existDataInBasketHistory = existsInArray(existProduct, value.id);

      const existItemInBasket = existsInArraySecond(cartItems, value.id);

      if (value.categoryID === 1) {
        try {
          Basket.push(value);
          setCartItems(Basket);
          toast.success("به سبد خرید اضافه شد");
        } catch (error) {
          console.log(error.message);
        }
      } else {
        if (existDataInBasketHistory === false) {
          if (existItemInBasket == false) {
            try {
              Basket.push(value);
              setCartItems(Basket);
              toast.success("به سبد خرید اضافه شد");
            } catch (error) {
              console.log(error.message);
            }
          } else {
            toast.error(
              "کاربر گرامی محصول مورد نظر را قبلا به سبد خرید اضافه کرده اید"
            );
          }
        } else {
          return toast.error("این محصول قبلا خریداری شده است.");
        }
      }
    } else {
      toast.error("لطفا ابتدا از بخش منو بالا وارد حساب کاربری خود شوید");
    }
  };

  return (
    <article className="single_product ">
      <div className="single_product_wrapper">
          <Link  to={`/product/${item.id}`}/>
      </div>

      <figure className="product-one-card">
        {/* ----------------------------------------- Product Image --------------------------------------- */}

        <ProductCard
          discount={discountPercentage(item.price, item.priceTakhfif)}
          item={item}
          hover={hover}
          link={`/product/${item.id}`}
          commingSoon={item.isCommingSoon}
        />

        {/* ----------------------------------------- End Product Image --------------------------------------- */}

        <figcaption className="product_content" style={commingSoon ? { minHeight: "50px" } : { minHeight: "150px" }}>
          {/* ------------------------------ title --------------------------- */}
          <p
            className="product_name"
            style={{
              fontSize: "16px",
              fontWeight: "500",
            }}
          >
            {commingSoon ? (
              <h3 className="price" style={{ color: "blue" }}>
                {item.title}
              </h3>
            ) : (
              <Link to={`/product/${item.id}`} className="text-info">
                {item.title}
              </Link>
            )}
          </p>
          {/* ------------------------------ price --------------------------- */}
          {item.price === item.priceTakhfif ? (
            item.price == 0 ? (
              <>{!commingSoon ? <h3 className="price">رایگان</h3> : null}</>
            ) : (
              <span className="old_price">{separate(item.price)} تومان</span>
            )
          ) : (
            <>
              <span className="old_price my-2 mr-3">
                <del>{separate(item.price)} تومان</del>
              </span>
              {item.price !== item.priceTakhfif && <span className="current_price">
                {separate(item.priceTakhfif)} تومان
              </span>}
            </>
          )}
          {/* ------------------------------ button  --------------------------- */}

          {!commingSoon ? (
            <div className="add_to_cart">
              {item.inventory > 0 ? ( <button
                style={{ color: "white" }}
                onClick={(e) => addToBasketHandler(e, item)}
                title="افزودن به سبد"
                className="btn btn-sm w-75 mt-auto  mx-auto"
              >
                افزودن به سبد
              </button>) : <button className="btn btn-sm w-75 mt-auto mx-auto" disabled>عدم موجودی</button>}
            </div>
          ) : null}
        </figcaption>
      </figure>
    </article>
  );
};

export default ProductOne;

// {/* <div className="bookWrap">
// <div className="book">
//   <img
//     src={item.img}
//     alt="product_image"
//     className="mx-auto cover"
//     style={{ width: "100%", height: "100%" }}
//   />
//   <div className="spine"></div>
// </div>
// </div> */}

// <div className="product_thumb relative">
// <Link className="primary_img" to={`/product/${item.id}`}>
//   <img
//     src={item.img}
//     alt="product_image"
//     className="mx-auto"
//     style={{ width: "100%", height: "100%" }}
//   />
// <div className="paper-1"></div>
// <div className="paper-2"></div>
// <div className="paper-3"></div>
// </Link>
// {/* <Link className="secondary_img" to={`/product/${item.id}`}>
//   <img
//     src={item.img}
//     alt="product_image"
//     className="mx-auto"
//     style={{ width: "100%", height: "100%" }}
//   />
// </Link> */}
// <div className="action_links">
//   <ul>
//     <li className="wishlist">
//       <a
//         style={{ color: "white" }}
//         onClick={(e) => addToFavorite(e, item.id)}
//         title="افزودن به علاقه‌مندی‌ها"
//       >
//         <i className="fa fa-heart-o" aria-hidden="true"></i>
//       </a>
//     </li>
//   </ul>
// </div>

// <div className="product_timing">
//   <div data-countdown="2043/12/15"></div>
// </div>
// </div>
